import Helper from '@/modules/helper';

export default class Commenter {
  constructor(options) {
    this.options = options;
  }

  create() {
    this.scan();
    this.binds();
  }

  binds() {
    const that = this;

    that.comments.on('click', '.comment__reply', function () {
      const self = $(this);
      const id = self.data('id');
      const name = self.data('name');

      that.noFeatured();
      that.setParent(id);
      that.showReplying(id, name);

      Helper.scrollTo(that.body);

      that.body.value = name + ', ';
      that.body.focus();
    });

    that.replying.on('click', 'a', function (evt) {
      evt.preventDefault();

      var anchor = $(this).data('anchor');

      that.noFeatured();

      $(anchor).addClass('comment__card--active');

      Helper.scrollTo(anchor);
    });

    document.querySelectorAll('[data-comment-scroll]').forEach(function (el) {
      el.addEventListener('click', function (evt) {
        evt.preventDefault();

        Helper.scrollTo(el.dataset.anchor);

        that.body.focus();
      });
    });

    if (this.cancel) {
      this.cancel.addEventListener('click', () => {
        this.body.value = '';
        this.parent.removeAttr('value');
        this.replying.removeClass('comment__replying-to--active');

        this.noFeatured();

        this.body.focus();
      });
    }
  }

  noFeatured() {
    $('.comment__card').removeClass('comment__card--active');
  }

  scan() {
    this.body = document.querySelector('#comment_body');
    this.comments = $('[data-comments]');
    this.parent = $('#comment_parent_id');
    this.cancel = document.querySelector('[data-comment-cancel]');
    this.replying = $('.comment__replying-to');
  }

  setParent(id) {
    this.parent.val(id);
  }

  showReplying(id, name) {
    var anchor = '#comment-' + id;

    this.replying
      .addClass('comment__replying-to--active')
      .find('strong')
      .html('<a href="' + anchor + '" data-anchor="' + anchor + '">' + name + '</a>');
  }
}
